import React from 'react';
import PropTypes from 'prop-types';
import { colors } from "../../styleguide";
import SvgSpinner from "./SvgSpinner";

function Spinner(_ref) {
  var small = _ref.small,
      white = _ref.white;
  return /*#__PURE__*/React.createElement(SvgSpinner, {
    color: white ? colors.white100 : colors.grey800,
    petalWidth: 8,
    size: small ? 25 : 42
  });
}

Spinner.propTypes = process.env.NODE_ENV !== "production" ? {
  small: PropTypes.bool,
  white: PropTypes.bool
} : {};
export default Spinner;
//# sourceMappingURL=Spinner.js.map